export const MODE = {
  CLEAR: "CLEAR",
  REMOVE: "REMOVE",
  EDIT: "EDIT",
};

export const defaultItemData = {
  item: null,
  type: null,
};
